import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  authorizedStatus: {
    color: theme.palette.statusLabel.success.primary,
    backgroundColor: theme.palette.statusLabel.success.secondary,
    fontWeight: 'bold',
  },
  statusLabelExpired: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    fontWeight: 'bold',
  },
  revokedStatus: {
    color: theme.palette.statusLabel.error.primary,
    backgroundColor: theme.palette.statusLabel.error.secondary,
    fontWeight: 'bold',
  },
  pendingStatus: {
    color: theme.palette.statusLabel.pending.primary,
    backgroundColor: theme.palette.statusLabel.pending.secondary,
    fontWeight: 'bold',
  },
  softDeletedStatus: {
    color: theme.palette.statusLabel.softDeleted.secondary,
    backgroundColor: theme.palette.statusLabel.softDeleted.primary,
    fontWeight: 'bold',
  },
  initialContent: {
    paddingLeft: theme.spacing(3),
  },
  finalContent: {
    paddingRight: theme.spacing(3),
  },
}))

export default styles
